import omit from 'lodash/omit';
import pick from 'lodash/pick';
import { SravniNewsSharedModelsCommentsPostLikesCount } from 'src/__generated__/news/Api';
import { CommentsTotal } from 'src/interfaces/comments';

import {
  IExtraMaterial,
  IHighlightedMaterial,
  IMaterial,
  TAuthor,
  TAuthorShort,
  TMaterialShort,
} from '../../../interfaces/news';

export const prepareQuery = <T>(query: T & { [key: string]: any }): T => {
  return {
    ...query,
    ...(query.ExcludedIds && {
      ExcludedIds: (Array.isArray(query.ExcludedIds) ? query.ExcludedIds : [query.ExcludedIds]).map((id) => +id),
    }),
    ...(query.Rubrics && {
      Rubrics: Array.isArray(query.Rubrics) ? query.Rubrics : [query.Rubrics],
    }),
    ...(query.placementId && {
      placementId: (Array.isArray(query.placementId) ? query.placementId : [query.placementId]).map((id) => +id),
    }),
    ...(query.Tags && {
      Tags: Array.isArray(query.Tags) ? query.Tags : [query.Tags],
    }),
    ...(query.excludeExternalsFromPlacements && {
      excludeExternalsFromPlacements: JSON.parse(query.excludeExternalsFromPlacements),
    }),
    ...(query.PageIndex && { PageIndex: Number.parseInt(query.PageIndex) }),
  } as T;
};

export const mergeLikesAndComments = (
  article: IMaterial,
  likes: SravniNewsSharedModelsCommentsPostLikesCount[] = [],
  comments: CommentsTotal[] = [],
): IMaterial => {
  const currentLikes = likes.find((el) => +el.postId === +article.id);
  const currentComments = comments.find((el) => +el.postId === +article.id);

  return {
    ...article,
    likes: currentLikes?.likesCount || article.likes,
    commentsCount: currentComments?.commentsCount || article.commentsCount,
  };
};

export const toHighlightsFormat = (material: IMaterial): IHighlightedMaterial => {
  return omit(material, ['htmlBody', 'htmlHead']);
};

export const toExtraMaterialsFormat = (materials: IMaterial[]): IExtraMaterial[] => {
  return materials.map((material) =>
    pick<IMaterial>(material, [
      'externalLink',
      'title',
      'visits',
      'publishDate',
      'miniPicture',
      'id',
      'alias',
      'type',
      'authorName',
    ]),
  );
};

export const prepareMaterial = (material: IMaterial) => {
  if (material.relationTo?.length) {
    material.relationTo = material.relationTo?.map((relatedMaterials) => omit(relatedMaterials, ['body']));
  }
  return material;
};

export const prepareMaterials = (materials: IMaterial[]) => {
  return materials.map(prepareMaterial);
};

export const prepareAuthors = (authors: TAuthor[]): TAuthorShort[] => {
  return authors.map((author) =>
    pick<TAuthor>(author, [
      'id',
      'displayName',
      'title',
      'rating',
      'isExpert',
      'vk',
      'ok',
      'telegram',
      'facebook',
      'instagram',
    ]),
  );
};

export const preparePopularMaterials = (list: IMaterial[]): TMaterialShort[] => {
  return list.map((item) =>
    pick<IMaterial>(item, [
      'id',
      'title',
      'picture',
      'miniPicture',
      'generatedPicture',
      'alias',
      'rubric',
      'type',
      'visits',
      'externalLink',
      'commentsCount',
      'createDate',
      'publishDate',
    ]),
  );
};
